/**
 * Copyrights © 2021 Sigitek
 * All Rights Reserved
 *
 * NOTICE:
 * All the information contained here are property of Sigitek
 * The intellectual and technical concepts contained here in are proprietary to Sigitek
 * Dissemination of this information, reproduction of this material and copying or distribution of this software
 * is strictly forbidden unless prior written perssion is obtained from Sigitek
 *
 * */

import React, { Component } from "react";
import "./Footer.css";

export default class componentName extends Component {
  render() {
    return (
      <footer>
        <h6>Copyrights © 2022 Sigitek. All Rights Reserved.</h6>
      </footer>
    );
  }
}
